import React from 'react';
import '../hojas-de-estilo/Boton.css'

function Boton(props){

    const esOperador = val => {
        return isNaN(val) && (val !== ".") && (val !== "=");
    };

    /*if(esOperador(props.children)){
        return (
        <div 
            className='boton-contenedor operador'
            onClick={() => props.manejarClic(props.children)}>
            {props.children}
        </div>
        );
    }else{
        return (
        <div 
            className='boton-contenedor'
            onClick={() => props.manejarClic(props.children)}>
            {props.children}
        </div>
    }*/ 

    return (
        <div 
            className={`boton-contenedor ${esOperador(props.children) ? 'operador' : ''}`.trimEnd()}
            onClick={() => props.manejarClic(props.children)}>
            {props.children}
        </div>

    )
}

export default Boton;